// extracted by mini-css-extract-plugin
export default {"dashboard-project":"style_dashboard-project__tx9pX","dashboard-header":"style_dashboard-header__kcNcq","dashboard-banner":"style_dashboard-banner__HkqPl"};